<template>
    <div v-if="modalData" class="general-modal-wrapper" :class="[{'fill-vw' : !isDesktop}, modalType]">
        <div class="general-content-modal" :class="modalClasses">
            <div class="modal-header" :class="{'navigation-mode' : headerNavigationMode, 'has-subTitle' : headerSubTitle}">
                <h2 class="header-title"> {{ modalData.title }} </h2>
                <h4 v-if="headerSubTitle" class="header-subtitle"> {{ headerSubTitle }} </h4>
                <i class="modal-close" :class="[ headerNavigationMode ? 'ecom-chevron-left' : 'ecom-close' ]" @click="modalClose"/>
            </div>
            <div class="modal-body" :class="{ 'h-100' : typeImageEdit }">
                <!-- use slots? -->
                <p v-if="typeText" class="body-info body-content-text themed-scrollbar" v-html="modalData.content"/>
                <FaqAccordion v-if="typeAccordion"/>
                <TextBodyDescription v-if="typeTextBodyDescription"/>
                <RecipeDescription v-if="typeRecipeDescription"/>
                <SmsValidation v-if="typeSmsValidation"/>
                <DescriptionForm v-if="typeDescriptionForm" @set-sub-header="setSubHeaderTitle"/>
                <RecipeForm v-if="typeRecipeForm"/>
                <ImageEdit v-if="typeImageEdit"/>
                <CatalogCart v-if="typeCatalogCart" :inner-component="isMixType" @set-sub-header="setSubHeaderTitle"/>
            </div>
        </div>
    </div>
</template>

<script>
import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';

//import sharedApi from '@/api/sharedApi';

import FaqAccordion from '@/components/Pastimes/Desktop/partials/modalSections/FaqAccordion';
import TextBodyDescription from '@/components/Pastimes/Desktop/partials/modalSections/TextBodyDescription';
import RecipeDescription from '@/components/Pastimes/Desktop/partials/modalSections/RecipeDescription';
import SmsValidation from '@/components/Pastimes/Desktop/partials/modalSections/SmsValidation';
import DescriptionForm from '@/components/Pastimes/Desktop/partials/modalSections/DescriptionForm';
import RecipeForm from '@/components/Pastimes/Desktop/partials/modalSections/RecipeForm';
import ImageEdit from '@/components/Pastimes/Desktop/partials/modalSections/ImageEdit';
import CatalogCart from '@/components/Pastimes/Desktop/partials/modalSections/CatalogCart';

export default {
    store,
    name: 'GeneralModal',
    components: {
        FaqAccordion,
        RecipeDescription,
        TextBodyDescription,
        SmsValidation,
        DescriptionForm,
        RecipeForm,
        ImageEdit,
        CatalogCart
    },
    props: {},
    data() {
        return {
            headerSubTitle: '',
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            const data = this.$store.getters.modalData;
            return !isEmpty(data) ? data : null;
        },
       /* minMode() {
            return this.typeSmsValidation;
        },*/
        modalClasses() {
            let cssClass = '';
            switch(this.modalType) {
                case 'smsValidation':
                    cssClass = 'min-mode overflow-visible'
                    break;
                case 'descriptionForm':
                case 'text':
                case 'accordion':
                    cssClass = this.isDesktop ? 'contained' : '';
                    break;
                case 'recipeForm':
                case 'catalogCart':    
                    cssClass = this.isDesktop ? 'contained large' : '';
                    break;    
                default:
                    break;    
            }
            
            return cssClass;
        },
       /* contained() {
            return this.typeDescriptionForm || this.typeRecipeForm;  
        },*/
        // body content type: text, accordion, media, form
        modalType() {
            return this.modalData ? this.modalData.contentType : '';
        },
        isMixType() {
            return this.modalData && this.modalData.isMixType ? this.modalData.isMixType : false;
        },
        // these go to a switch?
        typeText() {
            return this.modalType == 'text';
        },
        typeAccordion() { 
            return this.modalType == 'accordion';
        }, 
        typeImageEdit() { 
            return this.modalType == 'imageEdit';
        },
        typeTextBodyDescription() {
            return this.modalType == 'textBodyDescription';
        }, 
        typeRecipeDescription() {
            return this.modalType == 'recipeDescription';
        },
        typeSmsValidation() {
            return this.modalType == 'smsValidation';
        },
        typeDescriptionForm() {
            return this.modalType == 'descriptionForm';
        },
        typeRecipeForm() {
            return this.modalType == 'recipeForm';
        },
        typeCatalogCart() {
            return this.modalType == 'catalogCart';
        },
        headerNavigationMode() {
            return !this.isDesktop && (this.typeAccordion || this.typeText);
        }
    },
    watch: {},
    created() {
    },
    mounted() {
        // this.$nextTick(() => {
            
        // });
    },
    methods: {
        modalClose() {
            //this.$emit('modal-status', status);
            this.$store.dispatch('setModalStatus', {status: false, context: null});
        },
        setSubHeaderTitle(content = '') {
            this.headerSubTitle = content;
        }
    }
};
</script>

<style scoped>

</style>